// (function () {
//     'use strict';

//     angular.module("imApp").factory("selectProdChoiceService", ['$ihttp', function ($ihttp) {
//         let service = {
//             listProductTypes: function (parms) {
//                 return $ihttp.post({
//                     method: 132,
//                     parameters: parms || {}
//                 });
//             }
//         };

//         return service;
//     }]);
// })();
